var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-menu",
    {
      attrs: { "offset-y": "" },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function (ref) {
            var on = ref.on
            var attrs = ref.attrs
            return [
              _c(
                "v-btn",
                _vm._g(
                  _vm._b(
                    {
                      staticClass: "ma-0 pa-0 pl-2 pr-2",
                      attrs: {
                        id: "transparent_btn",
                        elevation: "0",
                        width: "2.5rem",
                        height: "2rem",
                      },
                    },
                    "v-btn",
                    attrs,
                    false
                  ),
                  on
                ),
                [
                  _c("v-img", {
                    staticClass: "ma-0 pa-0",
                    attrs: {
                      height: "2rem",
                      width: "2.5rem",
                      src: require("@/assets/images/dots.png"),
                    },
                  }),
                ],
                1
              ),
            ]
          },
        },
      ]),
    },
    [
      _c(
        "v-list",
        { staticClass: "ma-0 pa-0", attrs: { dense: "" } },
        [
          _c(
            "v-list-item",
            {
              staticClass: "pa-4",
              on: {
                click: function ($event) {
                  return _vm.showUserDetail(_vm.user)
                },
              },
            },
            [
              _c("v-list-item-title", { attrs: { align: "left" } }, [
                _vm._v(_vm._s(_vm.t("detailView"))),
              ]),
            ],
            1
          ),
          _c(
            "v-list-item",
            {
              staticClass: "pa-4",
              on: {
                click: function ($event) {
                  return _vm.deleteUser(_vm.user)
                },
              },
            },
            [
              _c("v-list-item-title", { attrs: { align: "left" } }, [
                _vm._v(_vm._s(_vm.t("delete"))),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }